enum LobbyTab {
    Lobby_Staff_Status = 1,
    Appointment_Status = 2,
    Central_Views = 3
}

export default LobbyTab